import React from "react";
import { Link } from "react-router-dom";
import { EmptyState } from "../components/RedlandComponents";

export default function NotFound() {
  return (
    <section className="section">
      <div className="container narrow center">
        <EmptyState message="This page could not be found." />
        <p style={{ marginTop: "20px" }}>
          <Link className="button button-primary" to="/">
            Return Home
          </Link>
        </p>
      </div>
    </section>
  );
}
